"use client"
/* */
import { createElement } from 'react';
import * as Aria from 'react-aria-components';
import clsx from 'clsx';
import styles from './Option.module.scss.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';

const Option = flowComponent("Option", (props) => {
  const { className, children, value, ref, ...rest } = props;
  const rootClassName = clsx(styles.option, className);
  return /* @__PURE__ */ createElement(
    Aria.ListBoxItem,
    {
      className: rootClassName,
      ref,
      ...rest,
      id: value,
      key: value
    },
    children
  );
});

export { Option, Option as default };
//# sourceMappingURL=Option.mjs.map
